import { taxNumberSchema } from "$lib/yup/util/tax-number"
import { MINIMUM_AGE } from "@tastyworks/tastyworks-api"
import {
  dateISOString,
  maxAge,
  minAge,
} from "@tastyworks/tastyworks-api/validate"
import { object, string } from "yup"
import { isValidTaxNumber } from "../personal-info/tax-information"

export const grantorSchema = object({
  firstName: string().required(),
  lastName: string().required(),
  middleName: string(),
})

export const grantorDetailsSchema = object({
  email: string().email().required(),
  taxNumber: taxNumberSchema
    .transform((value) => value?.replaceAll("-", ""))
    .test(
      "invalid-tax-number",
      "yup.common.taxInformation.invalidTaxNumber",
      isValidTaxNumber
    ),
  birthDate: dateISOString()
    .required()
    .test(minAge(MINIMUM_AGE))
    .test(maxAge(120)),
})

export const trustGrantorInformationSchema = object({
  grantor: grantorSchema,
  grantorDetails: grantorDetailsSchema,
})
